is there a way for the branch to show the current branch
<template>
  <div class="ts-overflow-hidden">
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('disciplinaryAction.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('disciplinaryAction.pageTitle'),
            href: '/disciplinary'
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <div class="ts-justify-start">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'disciplinary-create' })"
              >{{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="ts-flex">
            <ts-input
              v-model="search"
              style="width: 300px;"
              :placeholder="$t('disciplinaryAction.search')"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'disiplinary_title'
          }"
        >
          <template v-slot="{ record }">
            <td>
              {{ record.branch_name_en }}
            </td>
            <td class="ts-text-center ts-whitespace-nowrap">
              {{ record.action_card }}
            </td>
            <td class="ts-text-center">
              <span v-show="record.card_type == 'Red card'">
                <i class="ts-text-sm fas fa-file ts-text-red-500"></i>
              </span>
              <span v-show="record.card_type == 'Yellow card'">
                <i class="ts-text-sm fas fa-file ts-text-yellow-500"></i>
              </span>
              <span v-show="record.card_type == 'Appreciation'">
                <i class="ts-text-sm fas fa-file ts-text-blue-600"></i>
              </span>
            </td>
            <td>
              <span
                v-for="(detail, index) in record.details"
                v-show="record.is_action_type == 2"
              >
                <span v-for="(subject, index) in detail.subjects">
                  {{ subject.subject_name }} <br />
                </span>
              </span>
              <span v-show="record.is_action_type == 1">
                {{ record.subject_name }}
              </span>
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.class_name }}
            </td>
            <td>
              {{ record.grade_name_foreign }}
            </td>
            <td class="ts-text-center">
              {{ record.ac_year }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.term_name }}
            </td>
            <td>
              {{
                record.teacher_created_by
                  ? record.teacher_created_by
                  : record.user_created_by
              }}
            </td>
            <td class="ts-whitespace-nowrap">
              {{ record.created_date }}
            </td>
            <td class="text-right ts-whitespace-no-wrap ts-px-8">
              <a
                href="#"
                class="mr-2 text-info"
                @click.prevent="previewPdf(record)"
                v-tooltip="$t('preview')"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="400px"
    >
      <ts-loading-banner :loading="loadingFilter">
        <div class="ts-space-y-3">
          <div class="row">
            <div class="col-md-12 ts-mb-2">
              <label>{{ $t('disciplinaryAction.date') }}</label>
              <a-range-picker
                format="DD-MM-YYYY"
                :defaultValue="rangeDate"
                :defaultPickerValue="rangeDate"
                @change="dateRangeChange"
              >
                <template slot="renderExtraFooter"></template>
              </a-range-picker>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('disciplinaryAction.academicYear') }}</label>
              <div class="form-group ts-w-full">
                <a-select
                  style="width: 100%"
                  v-model="ac_year_id"
                  :options="years"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('disciplinaryAction.branch') }}</label>
              <a-select
                v-model="branch_id"
                mode="multiple"
                style="width: 100%"
                :placeholder="$t('all')"
                :max-tag-count="1"
                :max-tag-text-length="10"
                :options="branches"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
              ></a-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>{{ $t('disciplinaryAction.subjectType') }}</label>
              <a-select
                v-model="disciplinary_subject_id"
                mode="multiple"
                style="width: 100%"
                :placeholder="$t('all')"
                :max-tag-count="1"
                :max-tag-text-length="10"
                :options="disciplinarySubjects"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
              ></a-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 ts-mt-2">
              <label>{{ $t('disciplinaryAction.cardType') }}</label>
              <a-select
                v-model="card_type"
                mode="multiple"
                style="width: 100%"
                :placeholder="$t('all')"
                :max-tag-count="1"
                :max-tag-text-length="10"
                :options="cardTypes"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
              ></a-select>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-drawer>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
import PreviewPdf from './preview-pdf'

export default {
  name: 'disciplinary',
  components: {
    PreviewPdf
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      show_form: false,
      visible: false,
      loadingFilter: false,
      subject_loading: false,
      model: {},
      rangeDate: [moment().add(-1, 'months'), moment()],
      years: [],
      disciplinarySubjects: [],
      branches: [],
      cardTypes: [
        { value: 'Red card', label: 'Red card' },
        { value: 'Yellow card', label: 'Yellow card' },
        { value: 'Appreciation', label: 'Appreciation' }
      ],
      card_type: undefined,
      disciplinary_id: null
    }
  },
  computed: {
    ...mapState('disciplinaryAction', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('disciplinaryAction.branchName')
        },
        {
          name: this.$t('disciplinaryAction.cardNumber'),
          style: 'text-align: center;'
        },
        {
          name: this.$t('disciplinaryAction.cardType'),
          style: 'text-align: center;'
        },
        {
          name: this.$t('disciplinaryAction.subjectType')
        },
        {
          name: this.$t('disciplinaryAction.className')
        },
        {
          name: this.$t('disciplinaryAction.gradeName')
        },
        {
          name: this.$t('disciplinaryAction.academicYear'),
          style: 'text-align: center;'
        },
        {
          name: this.$t('disciplinaryAction.academicTerm')
        },
        {
          name: this.$t('disciplinaryAction.createdBy')
        },
        {
          name: this.$t('disciplinaryAction.createdDate')
        },
        {
          name: this.$t('action'),
          style: 'text-align: right;'
        }
      ]
    },
    search: {
      get() {
        return this.$store.state.disciplinaryAction.search
      },
      set(val) {
        this.$store.commit('disciplinaryAction/SET_SEARCH', val)
      }
    },
    ac_year_id: {
      get() {
        return this.$store.state.disciplinaryAction.ac_year_id
      },
      set(newValue) {
        this.$store.commit('disciplinaryAction/SET_YEAR_ID', newValue)
      }
    },
    disciplinary_subject_id: {
      get() {
        return this.$store.state.disciplinaryAction.disciplinary_subject_id
      },
      set(newValue) {
        this.$store.commit(
          'disciplinaryAction/SET_DISCIPLINARY_SUBJECT_ID',
          newValue
        )
      }
    },
    branch_id: {
      get() {
        return this.$store.state.disciplinaryAction.branch_id
      },
      set(newValue) {
        this.$store.commit('disciplinaryAction/SET_BRANCH_ID', newValue)
      }
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchResource()
  },
  methods: {
    async fetchResource() {
      await this.$store
        .dispatch('reportAcademic/getYear')
        .then(response => {
          this.years = response.data.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('disciplinaryAction/getDisciplinarySubject')
        .then(response => {
          this.disciplinarySubjects = response.data.map(el => ({
            value: el.id,
            label: el.subject_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('disciplinaryAction/getBranch')
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('disciplinaryAction/fetch', attributes)
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'disciplinaryAction/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'disciplinaryAction/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    previewPdf(data) {
      this.$modal.show(
        PreviewPdf,
        {
          disciplinary_id: data.disciplinary_id,
          student_id: data.student_id,
          card_type: data.card_type,
          acps_id: data.acps_id
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    close() {
      this.show_form = false
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('disciplinaryAction/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500),
    ac_year_id: debounce(function(value) {
      this.fetchData({ ac_year_id: value })
    }, 500),
    disciplinary_subject_id: debounce(function(value) {
      this.fetchData({ disciplinary_subject_id: value })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500),
    card_type: debounce(function(value) {
      this.fetchData({ card_type: value })
    }, 500)
  }
}
</script>
<style scoped lang="scss"></style>
